import NativeAgent from 'common/nativeAgent'
import Utils from 'common/utils'
import LocationPermissionStore from 'stores/locationPermissionStore'
import LocationStore from 'stores/locationStore'
import Constants from 'common/constants'

const SCHEDULE_TIMEOUT_MS = 1000 * 60 * 60 // 60 mins

class ForceLocationManager {
    constructor() {
        this.lastLocationReceivedTime = null
        this.isScheduled = false;
        this.timer = null
    }

    initialise() {
        LocationPermissionStore.registerForPermissionChangeCb(this.locationPermissionChangeHandler.bind(this))
        LocationStore.registerCbForNewGeoLocation(this.geoLocationChangeHandler.bind(this))
    }

    // PRAGMA-MARK:- Listeners and callbacks

    locationPermissionChangeHandler() {
        let currPermission = LocationPermissionStore.getPermissionStatus()
        if (currPermission !== Constants.LOCATION_PERMISSION_STATUS.GRANTED) {
            // Remove if scheduled
            if (this.isPeriodicUpdatesScheduled()) {
                this.unschedulePeriodUpdates()
            }
        } else {
            if (false === this.isPeriodicUpdatesScheduled()) {
                this.schedulePeriodicLocationUpdates()
            }
        }
    }

    geoLocationChangeHandler() {
        this.locationReceivedFromNative()
    }

    // PRAGMA-MARK:- Methods

    locationReceivedFromNative() {
        this.lastLocationReceivedTime = Date.now()

        if (this.isPeriodicUpdatesScheduled()) {
            // unschedule and schedule again
            this.unschedulePeriodUpdates()
            this.schedulePeriodicLocationUpdates()
        }
    }

    isPeriodicUpdatesScheduled() {
        return this.isScheduled
    }

    schedulePeriodicLocationUpdates() {
        this.isScheduled = true

        this.clearTimer()
        this.timer = setTimeout(() => {
            this.performLocationUpdate()
        }, SCHEDULE_TIMEOUT_MS);
    }

    performLocationUpdate() {
        let performUpdate = false
        if (Utils.isNull(this.lastLocationReceivedTime)) {
            performUpdate = true
        } else {
            let delta = Date.now() - this.lastLocationReceivedTime
            if (delta >= SCHEDULE_TIMEOUT_MS) {
                performUpdate = true
            }
        }

        if (false === performUpdate) {
            return
        }

        this.forceUpdateLocation()
        this.schedulePeriodicLocationUpdates()
    }

    forceUpdateLocation() {
        NativeAgent.initiateSilentLocationDetection()
    }

    unschedulePeriodUpdates() {
        this.isScheduled = false
        this.clearTimer()
    }

    clearTimer() {
        if (false === Utils.isNull(this.timer)) {
            clearTimeout(this.timer)
            this.timer = null
        }
    }
}

let instance = new ForceLocationManager()
export default instance


// WEBPACK FOOTER //
// ./src/manager/forceLocationManager.js